import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { Blade } from '../shared/Blade'
import SydButton from '../../../../../commonDesign/Button'
import { usePolicy } from '../../../../../../hooks/usePolicy'
import { useClientReviewContext } from '../ClientReviewContext'
import OverrideList from './OverrideList'

const useStyles = makeStyles((theme) => {
  return ({
    overrides: {
      padding: theme.layout.padding.medium
    },
    actions: {
      padding: theme.layout.padding.medium,
      display: 'flex',
      flexDirection: 'row-reverse',
      borderBottom: '1px solid var(--color-neutral-700)'
    }
  })
})

function AccountOverridesDetails ({ overrides }) {
  const classes = useStyles()
  const canEditOverrides = usePolicy('billing_edit_overrides')
  const cr = useClientReviewContext()

  if (!overrides) {
    return null
  }

  return (
    <Blade>
      {canEditOverrides ? (
        <div className={classes.actions}>
          <SydButton size='xs' icon='add' onClick={() => cr.dialogs.addAccountOverride()}>Add Account Override</SydButton>
        </div>
      ) : null}
      <div className={classes.overrides}>
        {!overrides?.length ? (
          <div className='__no-content'>
            No Account Overrides
          </div>
        ) : (
          <OverrideList overrides={overrides} display={a => (<span>({a.accountNumber}) {a.accountName}</span>)} />
        )}
      </div>
    </Blade>
  )
}

AccountOverridesDetails.propTypes = {
  overrides: PropTypes.any
}

export default AccountOverridesDetails
